import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoApple16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M13.3358 4.77209C12.8782 5.05227 12.4992 5.44396 12.2342 5.91053C11.9691 6.37709 11.8268 6.90327 11.8205 7.4398C11.8223 8.04367 12.0012 8.63373 12.3351 9.13693C12.669 9.64013 13.1431 10.0343 13.6988 10.2707C13.4797 10.9776 13.1554 11.6475 12.7369 12.2579C12.1381 13.1199 11.512 13.9818 10.5593 13.9818C9.60657 13.9818 9.36157 13.4283 8.26363 13.4283C7.19297 13.4283 6.81183 14 5.94075 14C5.06967 14 4.46181 13.2015 3.7631 12.2215C2.84016 10.8488 2.33292 9.23887 2.30225 7.58493C2.30225 4.86285 4.07165 3.42019 5.81371 3.42019C6.73923 3.42019 7.51057 4.02805 8.09123 4.02805C8.64477 4.02805 9.50677 3.38381 10.5593 3.38381C11.1004 3.36985 11.6367 3.48917 12.1209 3.73126C12.6051 3.97335 13.0223 4.33079 13.3358 4.77209ZM10.0602 2.23151C10.5242 1.68572 10.7868 0.99726 10.8043 0.281135C10.8051 0.186728 10.796 0.0925 10.7771 0C9.9801 0.0778513 9.2431 0.457701 8.7173 1.06163C8.2489 1.58567 7.97637 2.25575 7.94603 2.95798C7.94637 3.04338 7.9555 3.12852 7.9733 3.21205C8.0361 3.22393 8.0999 3.23002 8.16383 3.23024C8.5311 3.20101 8.88863 3.09741 9.21463 2.92572C9.5407 2.75403 9.82837 2.51784 10.0602 2.23151Z" fill={iconColor} /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoApple16;